import React, { PropTypes } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import { converDateIntoLocalwithmonth, timeAgo } from "Constants";
import Button from "react-bootstrap-button-loader";
import { BASE_IMAGES_URL } from "Constants";
import LocaleStrings from "../../../../../languages";
import renderHTML from "react-render-html";

class ReportissueModalList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      resetpassword: false,
      loading: false,
      allowingaccess: false,
      selectedUsers: [],
      showEmailPreviewModal: false,
    };
  }

  renderattachmentList = (namesArray) => {
    let item = _.map(namesArray, (values, index) => {
      let href = `${BASE_IMAGES_URL}/${values}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}`;
      var tempIdArr = values.split("/");
      return (
        <div className="mt-2">
          <a href={href} target="_blank">
            <div>{tempIdArr[3]}</div>
          </a>
        </div>
      );
    });

    return item;
  };

  render() {
    let { values, index, data } = this.props;
    var profileImageUrl = "../../style/images/custom-icons/user_2.png";
    var username = "";

    // if (
    //     data.clients_by_reportedby &&
    //     data.clients_by_reportedby.profileurl !== "" &&
    //     data.clients_by_reportedby.profileurl !== null
    // ) {
    //     profileImageUrl = `${BASE_IMAGES_URL}/${data.clients_by_reportedby.profileurl}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}`;
    // }
    let namesArray = [];
    let messagesenton = "";
    messagesenton = converDateIntoLocalwithmonth(values.createdon).format(
      "D MMM YYYY HH:mm A"
    );
    if (values.attachments != null && values.attachments != "") {
      namesArray = values.attachments.split(",");
    }

    var contentData = "";
    if (values?.description) {
      contentData = values?.description.replaceAll("\n", "<br/>");
    }
    return (
      <>
        {values.isdraft != true && values.isdraft != 1 ? (
          <>
            {values.repliedby !== null ? (
              <div className="admin-text-support-ticket">
                <div className="d-flex issue-margin-bottom">
                  <div className="menuicon-logo-supportticket-profile">
                    <img className="normal" src={profileImageUrl} />
                  </div>
                  <div className="pl-12">
                    <div className="subject-reportissue">
                      {_.startCase(values.subject)}
                    </div>
                    <div
                      className="desc-reportissue mt-1"
                      style={{ color: "#105efb" }}>
                      {" "}
                      {_.startCase(data?.clients_by_reportedby?.firstname)}{" "}
                      {_.startCase(data?.clients_by_reportedby?.lastname)}
                    </div>
                    <div className="desc-reportissue mt-1">
                      {" "}
                      {data?.clients_by_reportedby?.email}
                    </div>
                    <div className="desc-reportissue mt-1">
                      {" "}
                      {messagesenton}
                    </div>
                    {/* <div className="desc-reportissue mt-2"> {_.startCase(values.description)}</div> */}
                  </div>
                  <div style={{ marginLeft: "auto" }}>
                    {timeAgo(values.createdon)}
                  </div>
                </div>
                <div
                  className="desc-reportissue mt-2"
                  style={{ marginLeft: "60px" }}>
                  <div className="">{renderHTML(contentData)}</div>
                </div>
                {namesArray.length > 0 ? (
                  <div className="attachement-box">
                    {LocaleStrings.accountsetting_reportissue_attachments}
                    <div className="row">
                      {" "}
                      {this.renderattachmentList(namesArray)}
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            ) : (
              <div className="superadmin-text-support-ticket">
                <div className="d-flex issue-margin-bottom">
                  <div className="menuicon-logo-supportticket">
                    <img
                      className="normal"
                      src="../../style/images/v2_icons/side_menu_icons/Logo.png"
                    />
                  </div>
                  <div className="pl-12">
                    {/* <div className="desc-reportissue mt-2"> {_.startCase(values.description)}</div> */}
                    <div className="subject-reportissue">
                      {
                        LocaleStrings.accountsetting_reportissue_replyfromeventify
                      }
                    </div>
                    <div className="desc-reportissue mt-1">Support Team</div>
                    <div className="desc-reportissue mt-1">
                      {" "}
                      {messagesenton}
                    </div>
                  </div>
                  <div style={{ marginLeft: "auto" }}>
                    {timeAgo(values.createdon)}
                  </div>
                </div>
                <div
                  className="desc-reportissue mt-2"
                  style={{ marginLeft: "60px" }}>
                  <div className="">{renderHTML(contentData)}</div>
                  {namesArray.length > 0 ? (
                    <div className="attachement-box">
                      {LocaleStrings.accountsetting_reportissue_attachments}
                      <div className="row">
                        {" "}
                        {this.renderattachmentList(namesArray)}
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            )}
          </>
        ) : (
          ""
        )}
      </>
    );
  }
}

export var mapStateToProps = (state) => {
  return {
    session: state.session,
  };
};

export default connect(mapStateToProps, {})(ReportissueModalList);
